var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIkonaStoper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.012 4.392V9.04l3.745 2.791a4.632 4.632 0 00-1.282-6.745 4.711 4.711 0 00-2.462-.694zm0-1.192a5.84 5.84 0 11-5.883 5.84A5.853 5.853 0 017.011 3.2zM5.723 0a.331.331 0 00-.229.094.326.326 0 00-.093.227V.96a.317.317 0 00.322.32h.483v.848a6.962 6.962 0 107.817 6.912 6.869 6.869 0 00-1.083-3.709l.683-.548.3.372a.348.348 0 00.1.081.36.36 0 00.12.037.332.332 0 00.125-.012.291.291 0 00.111-.059l.5-.4a.319.319 0 00.047-.45l-1.622-1.989a.3.3 0 00-.1-.081.336.336 0 00-.12-.037.361.361 0 00-.126.012.321.321 0 00-.111.058l-.5.4a.311.311 0 00-.117.215.315.315 0 00.07.234l.3.373-.68.547a7.017 7.017 0 00-4.111-1.957v-.848h.484a.33.33 0 00.228-.093.324.324 0 00.094-.227V.32a.322.322 0 00-.094-.227.33.33 0 00-.228-.094z",
    fill: "#750b22"
  })));
}

export default SvgIkonaStoper;